<template>
  <div>
    <el-drawer
      custom-class="client-drawer notice-drawer"
      v-model="listDrawer.show"
      title="公告"
      append-to-body
    >
      <div class="notice-wrapper" v-infinite-scroll="load">
        <div
          v-for="(item, index) in listDrawer.data"
          :key="index"
          class="message-all"
          @click="noticeDetail(item)"
        >
          <div>
            <div class="title">
              <ab-svg name="my-gongzuo"></ab-svg>
              <h5>{{ item.typeName }}</h5>
              <i v-if="!item.isNotice"></i>
              <div>{{ item.startTime }}</div>
            </div>
            <div class="notice">{{ item.title }}</div>
            <p>{{ formatContent(item.content) }}</p>
          </div>
          <ul v-if="!item.isNotice">
            <li @click.stop="noRemind(item)">不再提醒</li>
          </ul>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="client-drawer notice-detail-drawer"
      v-model="detailDrawer.show"
      :title="detailDrawer.data.typeName"
      append-to-body
    >
      <template #default>
        <div class="title">
          <h5>{{ detailDrawer.data.title }}</h5>
          <span>{{ detailDrawer.data.startTime }}</span>
        </div>
        <div class="notice-content" v-html="detailDrawer.data.content"></div>
        <el-image style="width: 0;height: 0;" :src="viewImage" id="notice-review-img" :preview-src-list="srcList" />
      </template>

      <template #footer>
        <el-button
          @click="closeDetailDrawer"
        >取消</el-button>

        <el-button
          v-if="!detailDrawer.data.isNotice"
          type="primary"
          :loading="detailDrawer.loading"
          @click="confirmDetailDrawer"
        >不再提醒</el-button>
      </template>

    </el-drawer>
    
  
  </div>
</template>

<script>
export default {
  data() {
    return {
      listDrawer: {
        show: false,
        loading: false,
        data: []
      },
      detailDrawer: {
        show: false,
        loading: false,
        data: {}
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 首页直接展开未读公告详情
      intoDetail: false,
      viewImage: '',
      srcList: []
    }
  },

  computed: {
    unreadList() {
      return this.listDrawer.data.filter(e => e.isNotice === false)
    },
    unreadNotice() {
      return this.listDrawer.data.find(e => !e.isNotice)
    }
  },

  watch: {

  },

  mounted() {

  },

  methods: {
    init() {
      this.listDrawer.show = true
      this.listDrawer.loading = true
      this.listDrawer.data = []
      this.intoDetail = false
      this.getAllNoticeList().then(() => {
        this.listDrawer.loading = false
      })
    },

    load() {
      if (this.page.currentPage * this.page.pageSize < this.page.total) {
        this.page.currentPage++
        this.getAllNoticeList()
      }
    },

    initDetail() {
      this.intoDetail = true
      this.getAllNoticeList().then(() => {
        this.noticeDetail(this.unreadNotice)
      })
    },
    
    getAllNoticeList() {
      return new Promise((resolve, reject) => {
        this.$post('/p/platformNotice/getUserAllNoticeList', {
          data: {},
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            data.result.list.forEach(row => {
              if (new Date().getTime() > new Date(row.endTime).getTime()) { // 过期消息不再提醒
                row.isNotice = true
              }
            })
            this.listDrawer.data = this.listDrawer.data.concat(data.result.list)
            this.page.total = data.result.total
            resolve(data.result)
          } else {
            reject(data.message)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },

    // 列表不再提醒
    noRemind(row) {
      this.noFurtherNotice(row.id).then(() => {
        row.isNotice = true
      })
    },

    // 通知详情
    noticeDetail(row) {
      if (row) {
        row.content = row.content.replace('img', 'img class="msg-img-view"')
        this.detailDrawer.show = true
        this.detailDrawer.data = row
        setTimeout(() => {
          let that = this
          let img = document.querySelectorAll(".msg-img-view");
          for (let i = 0; i < img.length; i ++) {
            img[i].addEventListener('click', that.getImgAttr)
          }
        }, 1000)
      } else {
        this.detailDrawer.show = false
        this.detailDrawer.data = {}
      }
    },
    getImgAttr (e) {
      this.viewImage = e.target.getAttribute('src')
      this.srcList = [this.viewImage]
      setTimeout(() => {
        const event = new Event('click')
        let view = document.getElementById('notice-review-img')
        view.dispatchEvent(event)
      })
    },

    // 取消
    closeDetailDrawer() {
      // 首页直接打开详情的，进入下一条公告
      if (this.intoDetail) {
        this.listDrawer.data.find(e => e.id === this.detailDrawer.data.id).isNotice = true
        this.noticeDetail(this.unreadNotice)
      } else {
        this.detailDrawer.show = false
        this.detailDrawer.data = {
            isNotice: true
        }
      }
    },

    // 详情不再提醒
    confirmDetailDrawer() {
      this.noFurtherNotice(this.detailDrawer.data.id).then(() => {
        // 标记已读
        this.listDrawer.data.find(e => e.id === this.detailDrawer.data.id).isNotice = true
        this.closeDetailDrawer()
      })
    },

    // 不再提醒接口
    noFurtherNotice(id) {
      return new Promise((resolve, reject) => {
        this.$post('/p/platformNotice/noFurtherNotice', { id }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            resolve(data.result)
          } else {
            reject(data.message)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },

    // 去掉html标签
    formatContent(str) {
      return str ? str.replace(/<[^>]+>/g, '') : ''
    }
  }
}
</script>

<style lang="scss">
.notice-drawer.client-drawer {
  .el-drawer__body {
    padding-left: 0;
    padding-right: 0;
  }
  .message-all {
    position: relative;
    padding: 0 40px;
    & > div {
      padding: 20px 0;
      border-bottom: 1px solid #f0f2f5;
      .title {
        h5 {
          display: inline-block;
          font-size: 18px;
          color: #000;
          vertical-align: top;
        }
        .icon-svg {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          vertical-align: middle;
        }
        i {
          display: inline-block;
          width: 8px;
          height: 8px;
          margin-left: 5px;
          border-radius: 50%;
          background-color: #ff0000;
        }
        div {
          float: right;
          font-size: 14px;
          color: #757575;
        }
      }

      .notice {
        margin: 13px 0 15px;
        color: #000;
        font-size: 16px;
      }

      p {
        font-size: 14px;
        color: #757575;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    ul {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      padding: 10px 0;
      background: rgba(0, 0, 0, 0.8);
      border-bottom-left-radius: 20px;
      li {
        float: left;
        padding: 0 15px 0 20px;
        color: #fff;
        border-right: 1px solid #fff;
        cursor: pointer;
        &:last-child {
          border-right: 0px;
        }
      }
    }

    &:hover {
      background-color: #f2f7ff;
      cursor: pointer;
      ul {
        display: block;
      }
    }
    &:first-child > div {
      border-top: 1px solid #f0f2f5;
    }
  }
}

.notice-detail-drawer.client-drawer {
  .title {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f2f5;
    h5 {
      font-size: 16px;
      margin-bottom: 15px;
    }
    span {
      font-size: 14px;
      color: #757575;
    }
  }
  .notice-content {
    font-size: 14px;
    line-height: 150%;
    img {
      max-width: 100%;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>
